import React from 'react'
import { useTranslation } from 'react-i18next'
import { ArrowRight, Calendar, MessageCircle, CheckCircle } from 'lucide-react'
import { trackEmailClick } from '../utils/metaPixel'
import { sendMetaEvent } from '../utils/metaCapi'

const CTA = () => {
  const { t } = useTranslation()
  return (
    <section id="cta" className="py-20 sm:py-24 md:py-32 px-4 sm:px-6 bg-[#0a0a0f] relative overflow-hidden">
      {/* Background Effects */}
      <div className="absolute inset-0">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gradient-to-r from-purple-500/20 to-purple-500/20 rounded-full blur-3xl"></div>
        <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-purple-500/50 to-transparent"></div>
        <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-purple-500/50 to-transparent"></div>
      </div>

      <div className="container-custom relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-purple-500/10 border border-purple-500/30 rounded-full mb-8">
            <Calendar className="w-4 h-4 text-purple-400" />
            <span className="text-purple-400 font-medium text-sm">{t('cta.badge', 'Limited spots available')}</span>
          </div>

          {/* Heading */}
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-4 sm:mb-6 text-white">
            {t('cta.heading1', 'Ready to')} <span className="text-purple-400">{t('cta.heading2', 'Automate')}</span> {t('cta.heading3', 'Your Business?')}
          </h2>

          {/* Subheading */}
          <p className="text-base sm:text-xl md:text-2xl text-gray-400 mb-8 sm:mb-12 max-w-2xl mx-auto">
            {t('cta.subheading', "Book a free 30-minute call. We'll learn about your workflows and show you how we can save you time and improve performance.")}
          </p>

          {/* CTA Button */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8 sm:mb-12">
            <a
              href="https://cal.com/mostafa-elsheikh/30min"
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center justify-center gap-2 px-8 sm:px-12 py-4 sm:py-5 bg-purple-600 text-white font-semibold rounded-xl transition-all duration-200 hover:scale-105 active:scale-[0.98] hover:shadow-[0_0_40px_-10px_rgba(139,92,246,0.5)]"
              onClick={() => sendMetaEvent('Lead', 'book_call')}
            >
              <span>{t('cta.button', 'Book Your Free Call')}</span>
              <ArrowRight className="w-5 h-5" />
            </a>
          </div>

          {/* Trust Elements */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 text-gray-400">
            <div className="flex items-center gap-2">
              <CheckCircle className="w-5 h-5 text-purple-400" />
              <span>{t('cta.trust1', 'No commitment required')}</span>
            </div>
            <div className="hidden sm:block w-1 h-1 bg-gray-600 rounded-full"></div>
            <div className="flex items-center gap-2">
              <MessageCircle className="w-5 h-5 text-purple-400" />
              <span>{t('cta.trust2', 'Actionable insights in 30 min')}</span>
            </div>
            <div className="hidden sm:block w-1 h-1 bg-gray-600 rounded-full"></div>
            <div className="flex items-center gap-2">
              <Calendar className="w-5 h-5 text-purple-400" />
              <span>{t('cta.trust3', 'Clear automation roadmap')}</span>
            </div>
          </div>

          {/* Alternative Contact */}
          <div className="mt-12 pt-12 border-t border-white/10">
            <p className="text-gray-400 mb-4">{t('cta.preferEmail', 'Prefer email?')}</p>
            <a
              href="mailto:support@nodatx.com"
              className="text-purple-400 hover:text-purple-300 text-lg font-semibold transition-colors"
              onClick={trackEmailClick}
            >
              support@nodatx.com
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}

export default CTA